import axios from "axios";

const BASE_URL = process.env.APP_BASE_URL || 'https://apiv3.edustack360.com';

const baseapi = axios.create({
    baseURL: BASE_URL,
});

baseapi.interceptors.request.use((config)=>{

    //const token = sessionStorage.getItem('cpmstoken');
    const token = localStorage.getItem('cpmstoken');

    if(token)
    {
        config.headers.Authorization = `Bearer ${token}`;
    }

    const userInfo = JSON.parse( localStorage.getItem('userinfo') || '{}');

    const roleId = userInfo?.role_id;

    console.log('Role id====' + roleId);

    if (roleId === 2) 
    {

        const teamType = localStorage.getItem('team_type') || 'Executive';

        config.params = {
                ...(config.params || {}),
                team_type: teamType,
        };
    }


    return config;
},
(error) => Promise.reject(error)
);

export default baseapi;